var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('div',{staticClass:"block"},[_c('el-rate',{attrs:{"max":1,"value":_vm.file.isStarred?1:0},on:{"change":_vm.updateStatus}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }